import React from 'react';
import PropTypes from 'prop-types';
import PostLink from 'src/modules/shared/links/postLink';
import Avatar from 'src/components/avatar';
import linkUtils from 'src/utils/linkUtils';
import { truncate } from 'underscore.string';
import Card from 'src/components/card';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import { trackFootfallEvent } from 'src/utils/footfall';

const PostListCard = ({ posts, community, title, seeAllLink, seeAllOnClick, onPostClick, postType }) => (
  <Card
    seeAllLink={seeAllLink}
    seeAllOnClick={seeAllOnClick}
    title={title}
  >
    {posts.map(post => {
      return (
        <PostLink
          community={community}
          key={`${postType}-${post.postId}`}
          post={post}
          onClick={() => {
            trackFootfallEvent(footfallEventTypes.CLICKED, {
              clickType: 'post-side-bar',
              clickMetadata: {
                section: 'post-side-bar',
                element: postType,
              },
            });
            onPostClick(post);
          }}
        >
          <div className={`community__widget__${postType}`}>
            <div className={`community__widget__${postType}__avatar`}>
              <Avatar size="small" src={linkUtils.generateAvatarLinkFromHash(post.userImageHash)} />
            </div>
            <div className={`community__widget__${postType}__title`}>
              {truncate(post.title, 60)}
            </div>
          </div>
        </PostLink>
      );
    })}
  </Card>
);

PostListCard.propTypes = {
  community: PropTypes.object.isRequired,
  posts: PropTypes.array,
  postType: PropTypes.string,
  seeAllLink: PropTypes.string,
  seeAllOnClick: PropTypes.func,
  title: PropTypes.string,
  onPostClick: PropTypes.func,
};

PostListCard.defaultProps = {
  posts: [],
  title: '',
  seeAllLink: '',
  seeAllOnClick: null,
  onPostClick: () => {},
  postType: '',
};

export default PostListCard;
